import { IFormError } from '../../components/Forms/types';

export const TICKET_GET_TICKET = 'TICKET_GET_TICKET';
export const TICKET_SET_TICKET = 'TICKET_SET_TICKET';
export const TICKET_SET_ERRORS = 'TICKET_SET_ERRORS';
export const TICKET_SET_ACTIVITY = 'TICKET_SET_ACTIVITY';
export const TICKET_TOGGLE_LOADING = 'TICKET_TOGGLE_LOADING';
export const TICKET_ASSIGN_ACTIVITY_IS_OPEN_FIELDS = 'TICKET_ASSIGN_ACTIVITY_IS_OPEN_FIELDS';
export const TICKET_TOGGLE_ACTIVITY_IS_OPEN = 'TICKET_TOGGLE_ACTIVITY_IS_OPEN';
export const TICKET_TOGGLE_ACTIVITY_CONTENT_LOADING = 'TICKET_TOGGLE_ACTIVITY_CONTENT_LOADING';
export const TICKET_SET_COMMENT_VALUE = 'TICKET_SET_REPLY_VALUE';
export const TICKET_SET_SHOW_COMMENT_FORM = 'TICKET_SET_SHOW_COMMENT_FORM';
export const TICKET_SET_COMMENT_PROCESSING = 'TICKET_SET_REPLY_PROCESSING';
export const TICKET_SET_DESC_ERROR = 'TICKET_SET_DESC_ERROR';
export const TICKET_UPDATE_ESCALATION_NOTE = 'TICKET_UPDATE_ESCALATION_NOTE';
export const TICKET_TOGGLE_MODAL = 'TICKET_TOGGLE_MODAL';
export const TICKET_ESCALATION_TOGGLE_MODAL = 'TICKET_ESCALATION_TOGGLE_MODAL';
export const TICKET_ESCALATE_TICKET = 'TICKET_ESCALATE_TICKET';
export const TICKET_SET_ESCALATION_MODAL_ERROR_TEXT = 'TICKET_SET_ESCALATION_MODAL_ERROR_TEXT';
export const TOGGLE_TICKET_REASON_DROPDOWN = 'TOGGLE_TICKET_REASON_DROPDOWN';
export const TICKET_TOGGLE_MODAL_LOADING = 'TICKET_TOGGLE_MODAL_LOADING';
export const TICKET_TOGGLE_ESCALATION_MODAL_LOADING = 'TICKET_TOGGLE_ESCALATION_MODAL_LOADING';
export const TICKET_SET_ACTIVITY_ERROR = 'TICKET_SET_ACTIVITY_ERROR'

export interface IToggleTicketModalLoadingAction {
  type: typeof TICKET_TOGGLE_MODAL_LOADING;
}
export interface IToggleTicketEscalationModalLoadingAction {
  type: typeof TICKET_TOGGLE_ESCALATION_MODAL_LOADING;
}
export interface ITogglTicketReasonDropdownAction {
  type: typeof TOGGLE_TICKET_REASON_DROPDOWN;
}
export interface ISetEscalateTicketErrorText {
  type: typeof TICKET_SET_ESCALATION_MODAL_ERROR_TEXT;
  payload: string;
}
export interface IEscalateTicket {
  type: typeof TICKET_ESCALATE_TICKET;
}
export interface ITicketToggleModal {
  type: typeof TICKET_TOGGLE_MODAL;
}
export interface ITicketEscalationToggleModal {
  type: typeof TICKET_ESCALATION_TOGGLE_MODAL;
}
export interface IUpdateEscalationNote {
  type: typeof TICKET_UPDATE_ESCALATION_NOTE;
  payload: string;
}
export interface ISetTicketCommentProcessing {
  type: typeof TICKET_SET_COMMENT_PROCESSING;
  payload: boolean;
}
export interface ISetTicketDescError {
  type: typeof TICKET_SET_DESC_ERROR;
  payload: boolean;
}
export interface ISetTicketCommentValue {
  type: typeof TICKET_SET_COMMENT_VALUE;
  value: string;
}
export interface ISetTicketShowCommentForm {
  type: typeof TICKET_SET_SHOW_COMMENT_FORM;
}
export interface IAssignActivityIsOpenFields {
  type: typeof TICKET_ASSIGN_ACTIVITY_IS_OPEN_FIELDS;
}
export interface ISetTicketAction {
  type: typeof TICKET_GET_TICKET;
  data: object;
}
export interface ISetTicketErrorsAction {
  type: typeof TICKET_SET_ERRORS;
  errors: Array<IFormError>;
}
export interface IToggleTicketLoadingAction {
  type: typeof TICKET_TOGGLE_LOADING;
}
export interface IToggleTicketActivityContentLoading {
  type: typeof TICKET_TOGGLE_ACTIVITY_CONTENT_LOADING;
  id: string;
}
export interface IAddTicketActivityError {
  type: typeof TICKET_SET_ACTIVITY_ERROR;
  id: string;
  error: string;
}

export interface ISetTicketActivity {
  type: typeof TICKET_SET_ACTIVITY;
  data: IActivity;
}
export interface IActivity {
  id: string;
  type: string;
  createdOn: Record<string, any>;
  modifiedOn: Record<string, any>;
  subject: string;
  status: string;
  content: string;
  createdBy: string;
  emailAddress: Record<string, any>;
  isOpen?: boolean;
  emailAddresses: IEmailAddresses;
  showFullMessage: boolean;
  contentLoading: boolean;
  error?: string;

}
export interface IEmailAddresses {
  from: string;
  cc: string;
  to: string;
}
export interface IToggleActivity {
  type: typeof TICKET_TOGGLE_ACTIVITY_IS_OPEN;
  id: string;
}
export interface ITicketState {
  ticketModalLoading: boolean;
  escalationticketModalLoading: boolean;
  descError: boolean;
  commentProcessing: boolean;
  showCommentForm: boolean;
  commentValue: string;
  loading: boolean;
  readOnly: boolean;
  data: TTicket;
  errors: Array<IFormError>;
  reasonDropdownOpen: boolean;
}
export type TTicket = {
  assignedTo: string;
  id: string;
  ticketNumber: string;
  title: string;
  description: string;
  status: string;
  statusReason: string;
  escalationState: string;
  createdOn: object;
  modifiedOn: object;
  origin: string;
  priority: string;
  openedBy: string;
  activities: Array<IActivity>;
  escalationNote: string;
  modalOpen: boolean;
  escalationModalOpen: boolean;
  escalateModalErrorText: string;
  ticketWorker: TticketWorker;
};

export type TticketWorker = {
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  phone: string | null;
};

export type TicketActionTypes =
    ISetTicketAction |
    ISetTicketErrorsAction |
    IToggleTicketLoadingAction |
    IAssignActivityIsOpenFields |
    IToggleActivity |
    ISetTicketShowCommentForm |
    ISetTicketCommentValue |
    ISetTicketDescError |
    ISetTicketCommentProcessing |
    IUpdateEscalationNote |
    ITogglTicketReasonDropdownAction |
    ITicketToggleModal |
    ITicketEscalationToggleModal |
    IEscalateTicket |
    ISetEscalateTicketErrorText |
    IToggleTicketEscalationModalLoadingAction |
    IToggleTicketActivityContentLoading |
    ISetTicketActivity |
    IToggleTicketModalLoadingAction |
    IAddTicketActivityError;
